import { Component, ViewEncapsulation } from '@angular/core';
import { HelpDeskService } from '../../services/help-desk/help-desk.service';
import { content as footerContent } from './footer.content';

@Component({
  selector: 'generic-footer',
  templateUrl: './generic-footer.component.html',
  styleUrls: ['./generic-footer.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class GenericFooterComponent {
  public content: any = footerContent;

  constructor (
    private helpDeskService: HelpDeskService,
  ) {
    // TODO JR. Need to update footerContent once we are clear on what the combined privacy policy and terms of use will be
    // For now, use NYC as the default
    this.content = footerContent.nyc;
  }

  public linkActionFromId (id: string) {
    switch (id) {
      case 'get-help':
        this.helpDeskService.showHelp();
        break;
      default:
        break;
    }
  }
}
